import React from 'react';
import './log_in_mobile.css';

export default function CreateAccountMobileStep1({ formData, handleChange, errors, onNext, onNavigate }) {
  return (
    <div className="mobile-auth-container" dir="rtl">
      <div className="mobile-auth-header">
        <img className="mobile-gov-logo" src="/images/Emblem_of_Syria_(2025–present).svg.png" alt="شعار" />
        <h1 className="mobile-header-title">الجمهورية العربية السورية</h1>
        <h2 className="mobile-header-subtitle">وزارة الصحة</h2>
        <h3 className="mobile-header-platform">منصة التنبؤ بالأوبئة</h3>
      </div>
      <div className="mobile-auth-card">
        <h4 className="mobile-card-title">إنشاء حساب</h4>
        <form onSubmit={onNext}>
          
          <div className={`mobile-input-group ${errors?.name ? 'input-error' : ''}`}>
            <input type="text" name="name" placeholder="الاسم" value={formData.name || ''} onChange={handleChange} required />
            <i className="fa-solid fa-user mobile-input-icon"></i>
          </div>
          {errors?.name && <span className="mobile-error-text">{errors.name}</span>}

          <div className={`mobile-input-group ${errors?.username ? 'input-error' : ''}`}>
            <input type="text" name="username" placeholder="اسم المستخدم" value={formData.username || ''} onChange={handleChange} required />
            <i className="fa-solid fa-user mobile-input-icon"></i>
          </div>
          {errors?.username && <span className="mobile-error-text">{errors.username}</span>}

          <div className={`mobile-input-group ${errors?.email ? 'input-error' : ''}`}>
            <input type="email" name="email" placeholder="البريد الالكتروني" value={formData.email || ''} onChange={handleChange} required />
            <i className="fa-solid fa-envelope mobile-input-icon"></i>
          </div>
          {errors?.email && <span className="mobile-error-text">{errors.email}</span>}

          <div className="mobile-input-group">
            <input type="tel" name="phone" placeholder="رقم الهاتف" value={formData.phone || ''} onChange={handleChange} required />
            <i className="fa-solid fa-phone mobile-input-icon"></i>
          </div>

          <div className={`mobile-input-group ${errors?.syndicateNumber ? 'input-error' : ''}`}>
            <input type="text" name="syndicateNumber" placeholder="رقم النقابة" value={formData.syndicateNumber || ''} onChange={handleChange} required />
            <i className="fa-regular fa-id-badge mobile-input-icon"></i>
          </div>
          {errors?.syndicateNumber && <span className="mobile-error-text">{errors.syndicateNumber}</span>}

          <button type="submit" className="mobile-btn-submit">متابعة</button>
        </form>
        <div className="mobile-card-links" style={{ textAlign: 'center' }}>
          <p>لديك حساب بالفعل؟ <span onClick={() => onNavigate('login')} className="mobile-link-action">سجل دخول</span></p>
        </div>
      </div>
      <div className="mobile-footer-privacy">سياسة الخصوصية</div>
    </div>
  );
}